import { createClient } from '@supabase/supabase-js';
import { processLock } from '@supabase/auth-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY env vars');
}

// Use a per-tab in-memory lock (processLock) instead of the default cross-tab
// navigator.locks lock. The default lock serializes token refreshes across ALL
// tabs of the origin, so with several HookHouse tabs open a slow/contended
// refresh made every tab's auth op — and any UI awaiting it (e.g. a request
// that 401s and triggers refreshSession) — stall up to 5s ("gotrue lock not
// released within 5000ms"). processLock scopes locking to this tab; Supabase's
// server-side refresh-token reuse grace window keeps concurrent multi-tab
// refreshes safe (no spurious logout).
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { lock: processLock },
});
